export enum ParagraphType {
  IMAGE = 'image',
  TEXT = 'text',
  CONTENT_GROUP = 'content_group',
  VENUE_CARD = 'venue_card',
}

export interface IParagraph {
  content: string;
  type: ParagraphType;
}

export interface IArticle {
  id: number;
  title: string;
  date: string;
  link?: string;
  paragraph: IParagraph[];
}

export interface IGroupListItem {
  text: string;
  link?: string;
  description?: string;
  bold?: boolean;
}

export interface IContentGroupItem {
  title?: string;
  title_style?: 'bold' | 'normal';
  items: IGroupListItem[];
}

export interface IContentGroupParagraph {
  type: ParagraphType.CONTENT_GROUP;
  groups: IContentGroupItem[];
}

export interface IVenueLink {
  text: string;
  url: string;
}

export interface IVenueInfo {
  name: string;
  phone?: string;
  booking_link?: IVenueLink;
  address?: string;
  address_map?: string;
  facebook?: IVenueLink;
}

export interface IVenueCardParagraph {
  type: ParagraphType.VENUE_CARD;
  venues: IVenueInfo[];
}

export interface IContent {
  id: string;
  title: string;
  date: string;
  backLink?: string;
  paragraph: IParagraph[];
}
